import styled from '@emotion/styled'
import { concat, includes, without } from 'lodash'
import { LOCIZE_NAMESPACE } from 'main/common'
import { i18nKeyPrefix } from 'main/pages/Search/i18n'
import { breakpoints, Checkbox, Hidden, spacing, Strong, Text, Visible } from 'main/ui'
import { IFilters } from 'main/util/search'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import {
  Apply,
  CheckboxGroupContainer,
  Clear,
  FieldCopyContainer,
  FieldsContainer,
  FilterFormContainer as CommonFilterFormContainer,
  FilterFormSubmitContainer,
} from '../../common/FilterForm.styles'
import { ISearchFormProps } from '../../types'

const FilterFormContainer = styled(CommonFilterFormContainer)`
  @media (min-width: ${breakpoints.lg}px) {
    padding: ${spacing.majorScale(3)}px ${spacing.majorScale(4)}px ${spacing.majorScale(4)}px;
    max-width: 170px;
  }
`
const PRE = `${i18nKeyPrefix}-FILTERS-DAYS-PER-WEEK-FORM`

export default function FilterForm(props: ISearchFormProps) {
  const { filters, onChangeFilters, onRequestCloseForm } = props

  const [params, setParams] = React.useState<IFilters>({ ...filters })

  const { t } = useTranslation(LOCIZE_NAMESPACE)

  return (
    <FilterFormContainer>
      <Fields params={params} onChangeParams={setParams} />
      <Visible lg xl>
        <FilterFormSubmitContainer css={{ marginTop: spacing.minorScale(5) }}>
          <Clear data-pendo="daysPerWeekFilter-clear" onClick={() => handleClear()}>
            {t(`${PRE}-CLEAR`)}
          </Clear>
          <Apply data-pendo="daysPerWeekFilter-apply" onClick={() => handleApply()}>
            {t(`${PRE}-APPLY`)}
          </Apply>
        </FilterFormSubmitContainer>
      </Visible>
    </FilterFormContainer>
  )

  function handleApply() {
    onRequestCloseForm()
    onChangeFilters({ ...filters, daysPerWeek: params.daysPerWeek })
  }

  function handleClear() {
    setParams({ ...params, daysPerWeek: [] })
  }
}

interface IFieldsProps {
  params: IFilters
  onChangeParams: (params: IFilters) => void
}

export function Fields(fieldsProps: IFieldsProps) {
  const { params, onChangeParams } = fieldsProps
  const { t } = useTranslation(LOCIZE_NAMESPACE)

  const formOptions = [1, 2, 3, 4, 5]

  return (
    <div>
      <Visible lg xl>
        <Strong>{t(`${PRE}-COPY`)}</Strong>
      </Visible>
      <Hidden lg xl>
        <FieldCopyContainer>
          <Text>
            <Strong>{t(`${PRE}-TITLE`)}</Strong>
            {t(`${PRE}-COPY`)}
          </Text>
        </FieldCopyContainer>
      </Hidden>
      <FieldsContainer>
        <CheckboxGroupContainer>
          {formOptions.map(option => {
            const label = `${option} ${option > 1 ? t(`${PRE}-DAYS`) : t(`${PRE}-DAY`)}`
            return (
              <Checkbox
                data-pendo={`daysPerWeekFilter-${option}-${option > 1 ? 'days' : 'day'}`}
                key={option}
                checked={includes(params.daysPerWeek, option)}
                label={label}
                onChange={(checked: boolean) => {
                  checked
                    ? onChangeParams({ ...params, daysPerWeek: concat(params.daysPerWeek, option) })
                    : onChangeParams({
                        ...params,
                        daysPerWeek: without(params.daysPerWeek, option),
                      })
                }}
              />
            )
          })}
        </CheckboxGroupContainer>
      </FieldsContainer>
    </div>
  )
}
